<template>
  <div>
        <div class="top-campaigns glide">
            <div class="glide__track" data-glide-el="track">
                <div class="glide__slides">
                    <slot></slot>
                </div>
            </div>
            <div data-glide-el="controls">
                <button class="btn btn-glide prev" data-glide-dir="<">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.097" height="23.925" viewBox="0 0 13.097 23.925"><path id="arrow_left" data-name="arrow left" d="M373.177,465.635a.6.6,0,0,1,1.026-.426l10.4,10.4,10.4-10.4a.6.6,0,0,1,.851.851L385.03,476.888a.6.6,0,0,1-.851,0l-10.829-10.829A.59.59,0,0,1,373.177,465.635Z" transform="translate(477.63 -372.677) rotate(90)" fill="#fff" stroke="#fff" stroke-width="1"/></svg>
                </button>
                <button class="btn btn-glide next" data-glide-dir=">">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.097" height="23.925" viewBox="0 0 13.097 23.925"><path id="arrow_left" data-name="arrow left" d="M373.177,465.635a.6.6,0,0,1,1.026-.426l10.4,10.4,10.4-10.4a.6.6,0,0,1,.851.851L385.03,476.888a.6.6,0,0,1-.851,0l-10.829-10.829A.59.59,0,0,1,373.177,465.635Z" transform="translate(477.63 -372.677) rotate(90)" fill="#fff" stroke="#fff" stroke-width="1"/></svg>
                </button>
            </div>
        </div>
  </div>
</template>

<script>
import Glide from '@glidejs/glide';
export default {
    name: 'TopCampaigns',
    data() {
        return {
            campaignCategories: [],
        };
    },
    mounted() {
        new Glide('.glide', {
            autoplay: 5000,
            hoverpause: true,
        }).mount();
    },
};
</script>
